<div class="exception-body">
    <div class="exception-panel">
        <img [src]="assestBaseUrl + 'layout/images/icon-access.png'" alt="access" />

        <h1>Access Denied</h1>
        <p>You don’t have permissions to access this resource</p>
        <button type="button" pButton label="GO TO DASHBOARD" [routerLink]="['/dashboard']" class="p-button-secondary"></button>
    </div>
</div>
